import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Marquee from "react-fast-marquee";
import { Sparkles } from "lucide-react";

// 3 Highly-Featured Campaign Reels (Center Grid)
const FEATURED_REELS = [
  {
    id: "DMBKfJtIICM",
    instagramUrl: "https://www.instagram.com/reel/DMBKfJtIICM/?igsh=ZXNuNHBqaXdrOWdv"
  },
  {
    id: "DX19mInInq1",
    instagramUrl: "https://www.instagram.com/reel/DX19mInInq1/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=="
  },
  {
    id: "DTfec_hjUbe",
    instagramUrl: "https://www.instagram.com/reel/DTfec_hjUbe/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=="
  }
];

// Top Row Reels (Right-to-Left Auto-Scrolling)
const TOP_ROW_REELS = [
  { id: "DLRrq1wo9yn", instagramUrl: "https://www.instagram.com/reel/DLRrq1wo9yn/?igsh=MWZyemgzNXh2MmVudQ==" },
  { id: "DVqeq69jBCy", instagramUrl: "https://www.instagram.com/reel/DVqeq69jBCy/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DYd7PDCs9wv", instagramUrl: "https://www.instagram.com/reel/DYd7PDCs9wv/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DVTmWx5jFK9", instagramUrl: "https://www.instagram.com/reel/DVTmWx5jFK9/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DT-s7gtjDII", instagramUrl: "https://www.instagram.com/reel/DT-s7gtjDII/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DYSXsQaS83I", instagramUrl: "https://www.instagram.com/reel/DYSXsQaS83I/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DYZ27INSafn", instagramUrl: "https://www.instagram.com/reel/DYZ27INSafn/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DXCXY4jEp16", instagramUrl: "https://www.instagram.com/reel/DXCXY4jEp16/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DWk9lhvDE0F", instagramUrl: "https://www.instagram.com/reel/DWk9lhvDE0F/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DVOAKgok6bP", instagramUrl: "https://www.instagram.com/reel/DVOAKgok6bP/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DV0uBAOEyMr", instagramUrl: "https://www.instagram.com/reel/DV0uBAOEyMr/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DYZ2MIKJLog", instagramUrl: "https://www.instagram.com/reel/DYZ2MIKJLog/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DWgG0Z9iIi8", instagramUrl: "https://www.instagram.com/reel/DWgG0Z9iIi8/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DOgPZPUCWIL", instagramUrl: "https://www.instagram.com/reel/DOgPZPUCWIL/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DWslPrEkzUn", instagramUrl: "https://www.instagram.com/reel/DWslPrEkzUn/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DRG0IZNiDDW", instagramUrl: "https://www.instagram.com/reel/DRG0IZNiDDW/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DQmJSrnEisJ", instagramUrl: "https://www.instagram.com/reel/DQmJSrnEisJ/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DM_2iW6TUXb", instagramUrl: "https://www.instagram.com/reel/DM_2iW6TUXb/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DXGgtliDUcD", instagramUrl: "https://www.instagram.com/reel/DXGgtliDUcD/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DWd8E56jbGE", instagramUrl: "https://www.instagram.com/reel/DWd8E56jbGE/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DWWK_DfiCkZ", instagramUrl: "https://www.instagram.com/reel/DWWK_DfiCkZ/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" }
];

// Bottom Row Reels (Left-to-Right Auto-Scrolling)
const BOTTOM_ROW_REELS = [
  { id: "DJ_IwchvGrg", instagramUrl: "https://www.instagram.com/reel/DJ_IwchvGrg/?igsh=NmY1Ynd4aDc0azdn" },
  { id: "DVXmQigjJwt", instagramUrl: "https://www.instagram.com/reel/DVXmQigjJwt/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DWQIM2hkb1L", instagramUrl: "https://www.instagram.com/reel/DWQIM2hkb1L/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DVEJaF3E3_H", instagramUrl: "https://www.instagram.com/reel/DVEJaF3E3_H/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DYClYqKNGhl", instagramUrl: "https://www.instagram.com/reel/DYClYqKNGhl/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DXTw_zijadf", instagramUrl: "https://www.instagram.com/reel/DXTw_zijadf/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DSMtQC5DTFs", instagramUrl: "https://www.instagram.com/reel/DSMtQC5DTFs/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DRHCQiGjXBm", instagramUrl: "https://www.instagram.com/reel/DRHCQiGjXBm/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DYrNw7TpbjK", instagramUrl: "https://www.instagram.com/reel/DYrNw7TpbjK/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DW9VZMviWFI", instagramUrl: "https://www.instagram.com/reel/DW9VZMviWFI/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DWghvC8Am-9", instagramUrl: "https://www.instagram.com/reel/DWghvC8Am-9/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DYrskIAq61_", instagramUrl: "https://www.instagram.com/reel/DYrskIAq61_/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DYln7yiKm0I", instagramUrl: "https://www.instagram.com/reel/DYln7yiKm0I/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DYghGW9BRPm", instagramUrl: "https://www.instagram.com/reel/DYghGW9BRPm/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DYmAhvKFe_C", instagramUrl: "https://www.instagram.com/reel/DYmAhvKFe_C/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DYZtEPPFReF", instagramUrl: "https://www.instagram.com/reel/DYZtEPPFReF/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DX1eQAXjShY", instagramUrl: "https://www.instagram.com/reel/DX1eQAXjShY/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DYofP5RDwmL", instagramUrl: "https://www.instagram.com/reel/DYofP5RDwmL/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DYhR2wmEqQM", instagramUrl: "https://www.instagram.com/reel/DYhR2wmEqQM/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DW85m9pjMe3", instagramUrl: "https://www.instagram.com/reel/DW85m9pjMe3/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DYox5TkoFPn", instagramUrl: "https://www.instagram.com/reel/DYox5TkoFPn/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DYgrmxqvA4k", instagramUrl: "https://www.instagram.com/reel/DYgrmxqvA4k/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" },
  { id: "DYZNz1TI7PT", instagramUrl: "https://www.instagram.com/reel/DYZNz1TI7PT/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" }
];

const InstagramIcon = ({ size = 12 }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
  </svg>
);

// High-Fidelity Mini Reel Card for Horizontal Marquees
const CompactReelCard = ({ reel, index, prefix, onClick }) => {
  const displayLabel = `${prefix} #${String(index + 1).padStart(2, "0")}`;

  return (
    <div
      onClick={onClick}
      className="relative w-[130px] sm:w-[155px] aspect-[9/16] bg-black rounded-[24px] border border-white/5 shadow-[0_6px_30px_rgba(0,0,0,0.5)] overflow-hidden cursor-pointer group flex flex-col items-center justify-between p-1 transition-all duration-500 hover:border-[var(--gold)]/40 hover:shadow-[0_0_30px_rgba(201,169,97,0.18)] hover:-translate-y-1 mx-3 select-none"
    >
      {/* Decorative Gold Laser Line at top */}
      <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-[var(--gold)] to-transparent opacity-20 group-hover:opacity-100 transition-opacity duration-500 z-30" />

      {/* Live Instagram Embed iframe */}
      <div className="w-full h-full rounded-[20px] overflow-hidden bg-[#0d0c0a] relative z-10 flex flex-col">
        <iframe
          src={`https://www.instagram.com/reel/${reel.id}/embed/`}
          className="w-full h-full border-0 pointer-events-none"
          scrolling="no"
          allowFullScreen
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          style={{
            width: "100%",
            height: "100%",
            overflow: "hidden",
            background: "#0d0c0a"
          }}
        />
      </div>

      {/* Floating Center Frosted Glass Play Overlay */}
      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 bg-black/25 backdrop-blur-[1px] z-20">
        <div className="w-10 h-10 rounded-full bg-black/50 border border-white/10 flex items-center justify-center shadow-lg backdrop-blur-md transform translate-y-3 group-hover:translate-y-0 transition-transform duration-500">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="text-[var(--gold-bright)] ml-0.5"
          >
            <path d="M8 5v14l11-7z" />
          </svg>
        </div>
      </div>

      {/* Bottom Label Metadata */}
      <div className="absolute bottom-2 left-1/2 -translate-x-1/2 text-center w-full z-30 px-2 pointer-events-none drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]">
        <div className="inline-block bg-black/75 px-3 py-1 rounded-full border border-white/5 backdrop-blur-md">
          <span className="font-impact text-[8px] tracking-[0.25em] text-[var(--gold)] uppercase block">
            {displayLabel}
          </span>
        </div>
      </div>
    </div>
  );
};

// Device Frame Player component for the grid
const ReelPlayer = ({ reel, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.6, delay: index * 0.15 }}
      className="flex flex-col items-center group"
    >
      {/* iPhone Device Frame */}
      <div className="relative w-full max-w-[290px] aspect-[9/19] bg-black rounded-[42px] p-2 border-4 border-[#221c18] shadow-[0_0_40px_rgba(201,169,97,0.12)] ring-1 ring-[var(--gold)]/20 overflow-hidden flex flex-col z-20 transition-all duration-500 group-hover:shadow-[0_0_50px_rgba(201,169,97,0.25)] group-hover:ring-[var(--gold)]/45">
        
        {/* Dynamic Island bezel */}
        <div className="absolute top-3 left-1/2 -translate-x-1/2 w-20 h-5 bg-black rounded-full z-50 flex items-center justify-between px-3 pointer-events-none">
          <div className="w-1 h-1 rounded-full bg-blue-600/90" />
          <div className="w-6 h-0.5 bg-white/10 rounded-full" />
          <div className="w-1.5 h-1.5 rounded-full bg-emerald-500/80 animate-pulse" />
        </div>

        {/* Screen Viewport */}
        <div className="relative w-full h-full rounded-[34px] overflow-hidden bg-[#0d0c0a] flex flex-col z-30 border border-white/[0.03]">
          
          {/* Live Instagram Embed iframe */}
          <iframe
            src={`https://www.instagram.com/reel/${reel.id}/embed/`}
            className="w-full h-full border-0 z-10"
            scrolling="no"
            allowFullScreen
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            style={{
              width: "100%",
              height: "100%",
              overflow: "hidden",
              background: "#0d0c0a"
            }}
          />

          {/* Elegant direct overlay link to actual Instagram Reel at bottom */}
          <a 
            href={reel.instagramUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className="absolute bottom-5 left-1/2 -translate-x-1/2 z-40 px-4 py-2 bg-black/70 hover:bg-[var(--gold)] hover:text-black border border-white/15 hover:border-[var(--gold)] rounded-full text-white text-[9px] font-impact tracking-wider uppercase transition-all duration-300 backdrop-blur-md flex items-center gap-1.5 shadow-lg"
          >
            <InstagramIcon size={11} /> View on Instagram
          </a>

        </div>
      </div>
    </motion.div>
  );
};

const ReelsShowcase = () => {
  const [selectedReel, setSelectedReel] = useState(null);

  return (
    <section id="works" className="py-32 relative overflow-hidden bg-[var(--ink)] border-t border-[var(--rule)]">
      {/* Background Decorative Lighting */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[radial-gradient(circle_at_center,rgba(201,169,97,0.05)_0%,transparent_70%)] pointer-events-none" />

      <div className="w-full relative z-10">
        
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-20 px-6">
          <div className="flex items-center justify-center gap-4 mb-4">
            <span className="font-impact text-[11px] tracking-[0.4em] text-[var(--gold)]">WORKS-02</span>
            <span className="w-16 h-px bg-[var(--rule)]" />
            <span className="font-impact text-[11px] tracking-[0.4em] text-[var(--cream-muted)] uppercase">Creative Showcase</span>
          </div>
          <h2 className="font-display text-5xl md:text-7xl text-[var(--cream)] leading-tight">
            Cinematic <span className="italic gold-text">Reels</span> Portfolio
          </h2>
          <p className="mt-6 text-[var(--cream-muted)] text-base md:text-lg font-body leading-relaxed">
            Scroll-stopping, high-engagement creative campaigns. Tap any mini card to view the Reel interactively, or view our featured works in full focus below.
          </p>
        </div>

        {/* 1. TOP ROW: Infinite Horizontal Marquee (Right to Left) */}
        <div className="w-full mb-16 relative overflow-hidden py-4 border-y border-[var(--rule)] bg-black/10">
          <Marquee 
            direction="left" 
            speed={45} 
            pauseOnHover={true} 
            gradient={true} 
            gradientColor="#0a0908"
            gradientWidth={80}
          >
            {TOP_ROW_REELS.map((reel, idx) => (
              <CompactReelCard
                key={reel.id}
                reel={reel}
                index={idx}
                prefix="CAMPAIGN"
                onClick={() => setSelectedReel(reel)}
              />
            ))}
          </Marquee>
        </div>

        {/* 2. MIDDLE SECTION: Featured 3-Card Grid */}
        <div className="container-xl px-6 mb-20">
          <div className="text-center mb-12">
            <h3 className="font-impact text-xl sm:text-2xl tracking-[0.3em] text-[var(--gold)] uppercase flex items-center justify-center gap-2">
              <Sparkles size={16} /> Featured Campaigns <Sparkles size={16} />
            </h3>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 max-w-6xl mx-auto">
            {FEATURED_REELS.map((reel, idx) => (
              <ReelPlayer key={reel.id} reel={reel} index={idx} />
            ))}
          </div>
        </div>

        {/* 3. BOTTOM ROW: Infinite Horizontal Marquee (Left to Right) */}
        <div className="w-full mt-16 relative overflow-hidden py-4 border-y border-[var(--rule)] bg-black/10">
          <Marquee 
            direction="right" 
            speed={45} 
            pauseOnHover={true} 
            gradient={true} 
            gradientColor="#0a0908"
            gradientWidth={80}
          >
            {BOTTOM_ROW_REELS.map((reel, idx) => (
              <CompactReelCard
                key={reel.id}
                reel={reel}
                index={idx}
                prefix="CREATIVE"
                onClick={() => setSelectedReel(reel)}
              />
            ))}
          </Marquee>
        </div>

        {/* Dynamic Footer Callout */}
        <div className="mt-16 text-center px-6">
          <p className="text-[11px] text-[var(--muted)] italic font-body flex items-center justify-center gap-1.5">
            <Sparkles size={12} className="text-[var(--gold)]" /> Tap any Reel mockup to interact, unmute, or play campaign details.
          </p>
        </div>

      </div>

      {/* 4. PREMIUM LIGHTBOX PREVIEW MODAL */}
      <AnimatePresence>
        {selectedReel && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[999] flex items-center justify-center p-4 bg-black/85 backdrop-blur-xl"
            onClick={() => setSelectedReel(null)}
          >
            <motion.div
              initial={{ scale: 0.9, y: 30 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.9, y: 30 }}
              transition={{ type: "spring", damping: 25, stiffness: 180 }}
              className="relative w-full max-w-[300px] aspect-[9/19] flex items-center justify-center"
              onClick={(e) => e.stopPropagation()} // Prevent closing when interacting with player
            >
              {/* Glowing decorative backing aura */}
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(201,169,97,0.2)_0%,transparent_70%)] blur-3xl pointer-events-none" />

              {/* iPhone device mockup */}
              <div className="relative w-full h-full bg-black rounded-[42px] p-2 border-4 border-[#221c18] shadow-[0_0_50px_rgba(201,169,97,0.3)] ring-1 ring-[var(--gold)]/40 overflow-hidden flex flex-col z-20">
                
                {/* Dynamic Island bezel */}
                <div className="absolute top-3 left-1/2 -translate-x-1/2 w-20 h-5 bg-black rounded-full z-50 flex items-center justify-between px-3 pointer-events-none">
                  <div className="w-1 h-1 rounded-full bg-blue-600/90" />
                  <div className="w-6 h-0.5 bg-white/10 rounded-full" />
                  <div className="w-1.5 h-1.5 rounded-full bg-emerald-500/80 animate-pulse" />
                </div>

                {/* Screen Viewport */}
                <div className="relative w-full h-full rounded-[34px] overflow-hidden bg-[#0d0c0a] flex flex-col z-30 border border-white/[0.03]">
                  <iframe
                    src={`https://www.instagram.com/reel/${selectedReel.id}/embed/`}
                    className="w-full h-full border-0 z-10"
                    scrolling="no"
                    allowFullScreen
                    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                    style={{
                      width: "100%",
                      height: "100%",
                      overflow: "hidden",
                      background: "#0d0c0a"
                    }}
                  />

                  {/* Direct overlay link to actual Instagram Reel at bottom */}
                  <a 
                    href={selectedReel.instagramUrl} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="absolute bottom-5 left-1/2 -translate-x-1/2 z-40 px-4 py-2 bg-black/70 hover:bg-[var(--gold)] hover:text-black border border-white/15 hover:border-[var(--gold)] rounded-full text-white text-[9px] font-impact tracking-wider uppercase transition-all duration-300 backdrop-blur-md flex items-center gap-1.5 shadow-lg"
                  >
                    <InstagramIcon size={11} /> View on Instagram
                  </a>
                </div>
              </div>

              {/* Floating Close Button */}
              <button
                onClick={() => setSelectedReel(null)}
                className="absolute -top-12 right-0 md:-right-12 z-[1000] p-2.5 bg-black/85 hover:bg-[var(--gold)] hover:text-black border border-white/10 rounded-full text-white transition-all shadow-lg backdrop-blur-md flex items-center justify-center focus:outline-none"
                title="Close Player"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>

            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default ReelsShowcase;
